import React from "react";

const INITIAL = { open: false, mode: "hidden", title: "", message: "", onClose: null };

export default function OverlayHost() {
  const [state, setState] = React.useState(INITIAL);

  // API global window.overlay con soporte de onClose
  React.useEffect(() => {
    const setOverlayBusy = (busy) => {
      window.__overlayBusy = busy === true;
    };

    const api = {
      open: (opts = {}) => {
        const { mode = "loading", title = "", message = "", onClose = null } = opts;
        setOverlayBusy(true);
        setState({ open: true, mode, title, message, onClose });
      },
      loading: (message = "Procesando…", opts = {}) => {
        setOverlayBusy(true);
        setState({ open: true, mode: "loading", title: opts.title || "", message, onClose: opts.onClose || null });
        return () => api.close();
      },
      success: (message = "Operación realizada", opts = {}) => {
        setOverlayBusy(true);
        setState({ open: true, mode: "success", title: opts.title || "Operación realizada", message, onClose: opts.onClose || null });
      },
      error: (message = "Ocurrió un error", opts = {}) => {
        setOverlayBusy(true);
        setState({ open: true, mode: "error", title: opts.title || "Error", message, onClose: opts.onClose || null });
      },
      close: () => {
        setOverlayBusy(false);
        window.dispatchEvent(new CustomEvent("app:activity"));
        setState((prev) => {
          const cb = prev.onClose;
          // Ejecutar el callback después de cerrar, fuera del ciclo de render
          setTimeout(() => { try { cb && cb(); } catch {} }, 0);
          return INITIAL;
        });
      },
    };

    window.overlay = api;
    setOverlayBusy(false);

    const onOpen = (e) => api.open(e.detail || {});
    const onClose = () => api.close();

    window.addEventListener("overlay:open", onOpen);
    window.addEventListener("overlay:close", onClose);
    return () => {
      window.removeEventListener("overlay:open", onOpen);
      window.removeEventListener("overlay:close", onClose);
      setOverlayBusy(false);
      if (window.overlay === api) delete window.overlay;
    };
  }, []);

  // Bloquear ESC mientras esté abierto
  React.useEffect(() => {
    const onKey = (e) => {
      if (!state.open) return;
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    document.addEventListener("keydown", onKey, true);
    return () => document.removeEventListener("keydown", onKey, true);
  }, [state.open]);

  if (!state.open) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black/25 backdrop-blur-[1px] flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-xl px-6 py-5 w-[90%] max-w-md text-center">
        {/* LOADING */}
        {state.mode === "loading" && (
          <>
            <div className="mx-auto mb-3 h-10 w-10 rounded-full border-4 border-gray-300 border-t-transparent animate-spin" />
            {state.title ? <div className="text-gray-800 font-semibold">{state.title}</div> : null}
            <div className="mt-1 text-sm text-gray-600">{state.message || "Procesando…"}</div>
          </>
        )}

        {/* SUCCESS */}
        {state.mode === "success" && (
          <>
            <div className="mx-auto mb-3 h-10 w-10 rounded-full border-4 border-green-600 flex items-center justify-center">
              <div className="h-3 w-3 rounded-full bg-green-600" />
            </div>
            <div className="text-green-700 font-semibold">{state.title || "Operación realizada"}</div>
            <div className="mt-1 text-sm text-gray-700">{state.message}</div>
            <div className="mt-4">
              <button type="button" className="btn-fil" onClick={() => window.overlay?.close()}>
                Cerrar
              </button>
            </div>
          </>
        )}

        {/* ERROR */}
        {state.mode === "error" && (
          <>
            <div className="mx-auto mb-3 h-10 w-10 rounded-full border-4 border-red-600 flex items-center justify-center">
              <div className="h-3 w-3 rounded-full bg-red-600" />
            </div>
            <div className="text-red-700 font-semibold">{state.title || "Error"}</div>
            <div className="mt-1 text-sm text-gray-700">{state.message}</div>
            <div className="mt-4">
              <button type="button" className="btn-fil" onClick={() => window.overlay?.close()}>
                Entendido
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}